import axios from 'axios';
import {
    authHeader
} from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class SupportService {
    getListSupport(start_date, end_date) {
       if(start_date && end_date){
        return axios.get(API_URL + 'help-support?date_start='+start_date+'&date_end='+end_date, {
            headers: authHeader()
        });
       } else {
            return axios.get(API_URL + 'help-support', {
                headers: authHeader()
            });
       }
    }
    DetailHelpSupport(id) {
        return axios.get(API_URL + 'help-support/' + id, {
            headers: authHeader()
        });
    }

    updateSupport(id, data) {
        return axios.put(API_URL + 'help-support/' + id, data, {
            headers: authHeader()
        });
    }

    resetNumber(data) {
        return axios.post(API_URL + 'help-support/reset-number', data, {
            headers: authHeader()
        });
    }

    deactiveNumber(data) {
        return axios.post(API_URL + 'help-support/deactive-number', data, {
            headers: authHeader()
        });
    }

    forceExit(data) {
        return axios.post(API_URL + 'help-support/force-exit', data, {
            headers: authHeader()
        });
    }
}

export default new SupportService();